import React from "react";
import { Skeleton, Stack } from "@mui/material";
import { ShimmerTitle } from "react-shimmer-effects";

interface CommonShimmerProps {
    rows?: number; // number of rows to show
    height?: number; // height of each shimmer row
    variant?: "text" | "rectangular" | "circular"; // type of shimmer
}

const CommonShimmer: React.FC<CommonShimmerProps> = ({
    rows = 6,
    height = 40,
    variant = "rectangular",
}) => {
    return (
        <Stack spacing={1}>
            {Array.from(new Array(rows)).map((_, index) => (
                // <Skeleton key={index} variant={variant} height={height} animation="wave" />
                <ShimmerTitle line={4} gap={10} variant="primary" />
            ))}
        </Stack>
    );
};

export default CommonShimmer;
